import * as React from 'react'
import { lightTheme } from '@/customTheme'

type IconProps = {
  disabled?: boolean
  size?: number
}

function BackgroundSuggestIcon({ disabled, size = 24 }: IconProps) {
  const color = disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <g transform="translate(3 3)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.8789 0C15.9109 0.0000819094 16.6866 0.259848 17.2061 0.779297C17.7324 1.29883 17.9961 2.06836 17.9961 3.08691V14.9199C17.996 15.9382 17.7323 16.7042 17.2061 17.2168C16.6866 17.7361 15.9107 17.996 14.8789 17.9961H3.11719C2.09212 17.9961 1.3164 17.736 0.790039 17.2168C0.263756 16.7042 0.000084101 15.9382 0 14.9199V3.08691C0 2.06836 0.263672 1.29883 0.790039 0.779297C1.3164 0.259928 2.09196 0 3.11719 0H14.8789ZM13.4707 16.2529H14.8066C15.2645 16.2529 15.6201 16.1297 15.873 15.8838C16.1259 15.6378 16.2528 15.2751 16.2529 14.7969V13.4707L13.4707 16.2529ZM8.25781 16.2529H10.8711L16.2529 10.8711V8.25781L8.25781 16.2529ZM3.05176 16.248C3.09639 16.2505 3.14259 16.2529 3.18945 16.2529H5.65918L16.2529 5.65918V3.20996C16.2529 3.15656 16.2492 3.10422 16.2461 3.05371L3.05176 16.248ZM1.75391 12.3477V14.7969C1.75391 14.8466 1.75514 14.8951 1.75781 14.9424L14.9521 1.74805C14.9048 1.74515 14.8564 1.74316 14.8066 1.74316H12.3584L1.75391 12.3477ZM1.75391 7.14648V9.74902L9.75977 1.74316H7.15723L1.75391 7.14648ZM3.18945 1.74316C2.72476 1.74316 2.36913 1.86637 2.12305 2.1123C1.87695 2.3584 1.75391 2.72461 1.75391 3.20996V4.54785L4.55859 1.74316H3.18945Z"
          fill={color}
        />
      </g>
    </svg>
  )
}

export default BackgroundSuggestIcon
